<template>
  <b-modal
    title="Nova rota dinâmica"
    id="new_dynamic_route"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <label-required-field label="Rota" />
          <b-input ref="autofocus" v-model="url" />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            class="v-primary ml-1"
            @click="$bvModal.hide('new_dynamic_route')"
          >
            <i class="fa fa-arrow-left mr-1" /> VOLTAR
          </v-btn>
          <v-btn type="submit" class="v-success ml-1">
            <i class="fa fa-save mr-1" /> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import LabelRequiredField from "../components/LabelRequiredField.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";

export default {
  name: "NewDynamicRoute",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  data() {
    return {
      errors: [],
      loading: false,

      url: "",
    };
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.url = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      this.loading = true;

      try {
        const data = {
          url: this.url,
        };
        const response = await api.post("/admin/rest-home/dynamic-route", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_dynamic_route");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>